import React from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { LinkArrowSvg, one, two } from 'src/assets'
import { GeneralCard } from 'src/components/Global/Cards/Cards'
import { GeneralTitle } from 'src/components/Global/Text/TitleText'
import { CallToActionCard } from 'src/Pages/HomePage/homePageStyle'
import { useTypedSelector } from 'src/redux/index'

import {
  FlexContainerOne,
  FlexContainerTwo,
  SavingsFlexWrapper,
} from '../EmergencySavings/EmergencyStyle'
import CardCarousel from './Carousel/CardCarousel'
// LinkWrapper,
import { CardBtnWrapper, Container, TransactionContainer } from './style'
import { WebTransaction } from './WebTransaction/WebTransaction'
import { Balance, TrendSvg } from 'src/assets'

interface ICardData {
  id: number
  Icon: any
  balance: string
  title: string
  className: string
}

const GeneralSavings = () => {
  const portfolio = useTypedSelector(
    (state) => state.portfolios.portfolio.accounts
  )
  const investmentData = useTypedSelector((state) => state.invest.all?.plans!)
  const recent = investmentData?.slice(1, 2)
  const CardData: ICardData[] = [
    {
      id: 1,
      balance: portfolio?.saving_plans.general,
      title: 'Current Balance',
      Icon: Balance,
      className: 'card_one',
    },
    {
      id: 2,
      Icon: TrendSvg,
      balance: portfolio?.total_interest,
      title: 'Interests on savings',
      className: 'card_two',
    },
  ]

  return (
    <Container>
      <GeneralTitle>General Savings</GeneralTitle>
      <ToastContainer />

      <SavingsFlexWrapper>
        <FlexContainerOne>
          <CardBtnWrapper>
            <CardCarousel>
              {CardData.map(({ id, Icon, title, balance, className }) => {
                return (
                  <GeneralCard key={id} className={className}>
                    <div className="flex_wrapper">
                      <div className="icon_wrapper">
                        <img src={Icon} alt="" />
                      </div>
                      <div className="balance-wrapper">
                        <p className="title">{title}</p>
                        <h2 className="balance">{balance}</h2>
                      </div>
                    </div>
                  </GeneralCard>
                )
              })}
            </CardCarousel>
          </CardBtnWrapper>

          <div className="fixed-width">
            <TransactionContainer>
              <div className="web-transaction">
                <WebTransaction />
              </div>
            </TransactionContainer>
          </div>
        </FlexContainerOne>

        <FlexContainerTwo>
          {recent?.map((item: any) => (
            <CallToActionCard>
              <div className="header_img">
                <img src={item.image} alt="" className="image" />
              </div>

              <div className="card_body">
                <div className="title_user">
                  <p>{item.plan_name}</p>
                </div>

                <div className="card_text_link">
                  <p>{item.description.substring(0, 60)}...</p>
                  <Link to="/invest" className="call_to_action_link">
                    Join other investors
                    <span>
                      <img src={LinkArrowSvg} alt="" />
                    </span>
                  </Link>
                </div>
              </div>
            </CallToActionCard>
          ))}
        </FlexContainerTwo>
      </SavingsFlexWrapper>
    </Container>
  )
}

export { GeneralSavings }
